module.exports = __webpack_public_path__ + "img/Large-Bevel-Attachment-22.b50ae05e.png";